import { HttpsService, HttpStatus, IHttpsService } from "@/framework/network/http/httpsService";
import { UserService } from "@/modules/auth/services/UserService";
import { err, ok, Result } from "neverthrow";
import { isSamoon } from "@/framework/utilities/isSamoon";
import { isEmpty } from "@/framework/utilities/isEmpty";
import CustomError from "@/framework/errors/CustomError";

export interface IAccessLoggerService {
  sendAccessLog(log: any): Promise<Result<null, Error>>;
}

const ENDPOINT = isSamoon()
  ? `${process.env.VUE_APP_KTZN_BH_FE_STAFF_DOMAIN}accesslog/access-log`
  : `${process.env.VUE_APP_KTZN_FE_DOMAIN}accesslog/access-log`;

export class AccessLoggerService implements IAccessLoggerService {
  private _httpsService: IHttpsService;

  constructor(httpService: IHttpsService = new HttpsService()) {
    this._httpsService = httpService;
  }

  async sendAccessLog(log: any): Promise<Result<null, Error>> {
    try {
      const accessId = await new UserService().getUserAccessId();
      if (accessId.isErr()) {
        console.log("Access log cannot be send, user not found.");
        return err(
          new CustomError(CustomError.Type.general, accessId.error, "Access log cannot be send, user not found.")
        );
      }
      const kotoznaService = "in-room";
      let logData = log.data;

      if (!isEmpty(accessId)) {
        logData = Object.assign({ access_id: accessId.value }, logData);
      }

      const body = {
        user_id: accessId.value,
        category: log.category,
        action: log.action,
        data: logData,
        service: kotoznaService,
        executed_at: new Date().getTime(),
      };

      console.log("sendAccessLogData", JSON.stringify(body));

      const res = await this._httpsService.sendHttpRequestPost(body, ENDPOINT);
      if (res.status == HttpStatus.accepted) {
        console.log("Successfully sendAccessLog");
        return ok(null);
      } else {
        return err(new CustomError(CustomError.Type.general, res, "Could not sent sendAccessLog "));
      }
    } catch (e) {
      return err(new CustomError(CustomError.Type.general, e, "Could not sent sendAccessLog "));
    }
  }
}
